import React from "react";
import "./Contacthero.css";

export default function Contacthero({
  bgImage = "/image2.jpg",
  title = "Contact Us",
  breadcrumbLeft = "Home",
  breadcrumbRight = "Contact Us",
}) {
  return (
    <section
      className="contact-hero"
      style={{ backgroundImage: `url(${bgImage})` }}
      aria-label="Contact hero banner"
    >
      {/* Dark overlay with new colors */}
      <div className="contact-hero__overlay" aria-hidden="true" />

      <div className="contact-hero__inner">
        <h1 className="contact-hero__title">{title}</h1>

        <div className="contact-hero__crumbs" aria-label="Breadcrumb">
          <span className="contact-hero__crumb">{breadcrumbLeft}</span>
          <span className="contact-hero__sep" aria-hidden="true">
            /
          </span>
          <span className="contact-hero__crumb contact-hero__crumb--active">
            {breadcrumbRight}
          </span>
        </div>
      </div>
    </section>
  );
}